export const SPOTIFY_HOST = 'open.spotify.com';

export const INSTAGRAM_EMBED_DEFAULT_HEIGHT = 739;
export const INSTAGRAM_EMBED_MAX_WIDTH_CLASSNAME = 'max-w-[460px]';

export const SPOTIFY_EMBED_DEFAULT_HEIGHT = 352;
export const SPOTIFY_EMBED_MAX_WIDTH_CLASSNAME = 'max-w-[624px]';

export const TIKTOK_EMBED_DEFAULT_HEIGHT = 739;
export const TIKTOK_EMBED_MAX_WIDTH_CLASSNAME = 'max-w-[325px]';

export const YOUTUBE_SHORT_EMBED_DEFAULT_HEIGHT = 578;
export const YOUTUBE_SHORT_EMBED_MAX_WIDTH_CLASSNAME = 'max-w-[325px]';

export const YOUTUBE_EMBED_MAX_WIDTH_CLASSNAME = 'max-w-[660px]';

export const getUrlHost = (url: string): string | null => {
  try {
    return new URL(url).hostname;
  } catch {
    return null;
  }
};

export const hostMatches = (url: string, domain: string): boolean => {
  const host = getUrlHost(url);
  return !!host && (host === domain || host.endsWith(`.${domain}`));
};

export const getInstagramEmbedSrc = (permalinkOrUrl: string): string | null => {
  const match = /instagram\.com\/(p|reel|tv)\/([^/?#]+)/.exec(permalinkOrUrl);
  if (!match) return null;
  return `https://www.instagram.com/${match[1]}/${match[2]}/embed`;
};

export const getTiktokEmbedSrc = (videoId: string): string | null =>
  /^\d+$/.test(videoId) ? `https://www.tiktok.com/embed/v2/${videoId}` : null;

export const getTiktokEmbedSrcFromUrl = (url: string): string | null => {
  const match = /tiktok\.com\/@[\w.-]+\/(?:video|photo)\/(\d+)/.exec(url);
  return match ? getTiktokEmbedSrc(match[1]) : null;
};

// vm.tiktok.com / vt.tiktok.com short links (e.g. from Share -> Copy link) don't carry the
// video ID, so it's resolved via our API route, which proxies TikTok's oEmbed endpoint and
// caches the result (a given short link always resolves to the same post).
export const resolveTiktokEmbedSrc = async (url: string): Promise<string | null> => {
  try {
    const res = await fetch(`/api/articles/resolve-tiktok-embed?url=${encodeURIComponent(url)}`);
    if (!res.ok) return null;
    const data = await res.json();
    return data?.src || null;
  } catch {
    return null;
  }
};

export const getYoutubeShortEmbedSrc = (url: string): string | null => {
  const match = /youtube\.com\/shorts\/([^/?#]+)/.exec(url);
  return match ? `https://www.youtube.com/embed/${match[1]}` : null;
};

export const getYoutubeEmbedSrcFromUrl = (url: string): string | null => {
  const match = /youtube\.com\/(?:watch\?v=|embed\/)([^&?#/]+)/.exec(url);
  return match ? `https://www.youtube.com/embed/${match[1]}` : null;
};

export const getSpotifyEmbedSrcFromUrl = (url: string): string | null => {
  const match =
    /open\.spotify\.com\/(track|episode|album|playlist|show|artist)\/([A-Za-z0-9]+)/.exec(url);
  return match ? `https://open.spotify.com/embed/${match[1]}/${match[2]}` : null;
};
